import template from './ko-field-view-time.html';

class TimeViewComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);

		// Create a computed observable that formats the time
		this.formattedValue = ko.computed(() => {
			const time = this.value();
			if (!time) return '';
			
			// Handle both HH:mm:ss and HH:mm formats
			const parts = time.split(':');
			if (parts.length >= 2)
				return `${parts[0]}:${parts[1]}`; // Return only HH:mm

			return time;
		});
	}
}

export default {
	name: 'ko-field-view-time',
	viewModel: TimeViewComponentVM,
	module_type: 'ko',
	template: template
} 